import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  padding: 50px 0;
  margin-bottom: 75px;
`

const Text = styled.div`
  font-weight: 300;
`

const BlockQuote = Text.withComponent('blockquote').extend`
  border: 0;
  font-size: 30px;
  line-height: 40px;
  margin: 0 0 40px;
  padding: 0;

  p {
    margin-bottom: 0;
  }

  ${media.xs`
    font-size: 18px;
    line-height: 25px;
  `}
`

export default class LeadIn extends Component {
  render() {
    const { text } = this.props
    
    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={9}
              smOffset={3}
            >
              <BlockQuote dangerouslySetInnerHTML={{ __html: text }} />
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/LeadIn/index.js